import React, { useState } from 'react';
import { Link, NavLink, useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/AuthContext';
import { BrandIcon } from './BrandIcon';

/**
 * Direction B topbar for intrnauts.ai. Replaces the legacy <Header /> on .ai
 * builds. Renders: brand mark (icon + wordmark + pulsing dot) — nav (mono,
 * uppercase) — version chip. Mobile collapses nav to a hamburger drawer.
 * The pulsing dot's animation is controlled by ai.css under prefers-reduced-motion.
 */
export const AiHeader: React.FC = () => {
  const { isAuthenticated, isAdmin, isUserAdmin, logout } = useAuth();
  const navigate = useNavigate();
  const [open, setOpen] = useState(false);

  const close = () => setOpen(false);
  const handleLogout = () => { logout(); navigate('/'); close(); };

  return (
    <header className="ai-topbar">
      <Link to="/" className="ai-brand" onClick={close}>
        <span className="brand-mark">
          <BrandIcon className="brand-icon" />
          <span className="dot" aria-hidden="true" />
        </span>
        <span className="wordmark">intrnauts.ai</span>
      </Link>

      <button
        className="ai-mobile-toggle"
        onClick={() => setOpen(o => !o)}
        aria-label="Toggle navigation menu"
        aria-expanded={open}
      >
        <span className={`ai-hamburger ${open ? 'active' : ''}`}>
          <span /><span /><span />
        </span>
      </button>

      <nav className={`ai-nav ${open ? 'open' : ''}`} aria-label="Primary">
        <NavLink to="/about" onClick={close}>About</NavLink>
        <NavLink to="/services" onClick={close}>Services</NavLink>
        <NavLink to="/contact" onClick={close}>Contact</NavLink>
        {isAuthenticated && (
          <>
            <NavLink to="/profile" onClick={close}>Profile</NavLink>
            {(isAdmin || isUserAdmin) && <NavLink to="/admin" onClick={close}>Admin</NavLink>}
            <button onClick={handleLogout} className="ai-logout-btn">Logout</button>
          </>
        )}
      </nav>

      <div className="ai-version" aria-hidden="true">v.2026.05</div>
    </header>
  );
};

export default AiHeader;
